




<template>
<div>
<v-card  >
<v-toolbar   height="42"    color="#4A76A8" dark flat> <v-card-title>Сообщение в личку</v-card-title> <v-spacer></v-spacer> <v-icon @click="close()">mdi-close</v-icon>  </v-toolbar>
<v-card-text>
<v-textarea  color="#4A76A8"


  box
label="Ведите ваше сообщение"
>

</v-textarea>




</v-card-text>

<v-card-actions>
<v-spacer></v-spacer>
<v-btn @click="close()" small flat color="#4A76A8">Отменить</v-btn>  <v-btn  @click="messageSave()" small color="#4A76A8"  class="white--text" > Сохранить</v-btn>
</v-card-actions>
</v-card>
</div>
</template>

<script>


export default {
props:['newTask' ],
  data () {
    return {

    }
  },
methods: {
 close: function(){
   this.newTask.modals.message = false
   this.newTask.actions.messageSend.activated = false
 },
 messageSave: function(){
   this.newTask.modals.message = false

 },
},

}
</script>

<style   >

</style>
